import { render, staticRenderFns } from "./DirectorDashboard.vue?vue&type=template&id=92815e8c&scoped=true&"
import script from "./DirectorDashboard.vue?vue&type=script&lang=js&"
export * from "./DirectorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DirectorDashboard.vue?vue&type=style&index=0&id=92815e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92815e8c",
  null
  
)

export default component.exports